import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @ViewChild('navbar',{static:true}) navbar:any
  constructor(private route:Router, private router: Router) { }

  ngOnInit() {
    // this.col();
  }
  // myFunction(x) {
  //   x.classList.toggle("change");
  // }
  home() {
      this.router.navigate(['home'])
  }
  open:boolean
  col1(param){
    this.route.navigate([param])
  }
}
